var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.data
    ? _c("div", { staticClass: "d-fast-payment-system" }, [
        _c(
          "h3",
          { staticClass: "d-fast-payment-system__title" },
          [
            _c("span", [
              _vm._v("Оплата заказа № " + _vm._s(_vm.data.orderNumber) + " "),
              _c("span", { staticClass: "nowrap" }, [_vm._v("по QR-коду")])
            ]),
            _c("f-sprite-icon", {
              staticClass: "d-fast-payment-system__spb-icon",
              attrs: { "icon-link": _vm.$options.icons.IconSpb.id }
            })
          ],
          1
        ),
        _c("div", { staticClass: "d-fast-payment-system__price" }, [
          _vm._v("\n    Сумма заказа:"),
          _c("span", [
            _vm._v(_vm._s(_vm._f("price")(_vm.data.totalPrice)) + " ₽")
          ])
        ]),
        _c("div", { staticClass: "d-fast-payment-system__content" }, [
          _c(
            "div",
            { staticClass: "d-fast-payment-system__qr" },
            [
              _vm.loading
                ? _c("ui-loader", {
                    staticClass: "d-fast-payment-system__loader",
                    attrs: { size: "64" }
                  })
                : _vm._e(),
              _c("canvas", { ref: "qr" })
            ],
            1
          ),
          _vm._m(0)
        ])
      ])
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ol", { staticClass: "d-fast-payment-system__list" }, [
      _c("li", [
        _vm._v("\n        Наведите камеру смартфона на QR-код\n      ")
      ]),
      _c("li", [
        _vm._v(
          "\n        На экране появится выбор приложения банка. Следуйте дальнейшим инструкциям в телефоне.\n        Если не сработало, переходите к шагу 3\n      "
        )
      ]),
      _c("li", [
        _vm._v(
          "\n        Откройте приложение банка в телефоне, перейдите в раздел «Платежи»\n      "
        )
      ]),
      _c("li", [
        _vm._v(
          "\n        Выберите пункт «Оплата по QR-коду»\n        и отсканируйте QR-код\n      "
        )
      ]),
      _c("li", [
        _vm._v(
          "\n        Заказ сформируется в течение минуты после оплаты\n      "
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }